import React  from 'react';
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Container } from "@mui/material";
import FallbackPageStyles from "./FallBackPageStyles";
import logo from "../../Assets/Oops.png";

const FallbackPage = () => {
  const navigate = useNavigate();
  return (
    <FallbackPageStyles className="gridContainer">
        <Container className="midContainer" >
          <img className="imageStyle" src={logo} alt="" />
          <Typography
            variant="h5"
            color="textMain"
            fontWeight="bold"
            className="title"
          >
           PAGE NOT FOUND
          </Typography> 
          <Typography>Sorry but this page you're looking for does not exist, has been removed, or is temporarily unavailable</Typography>
          <Box className="buttonsContainer">
              <Button
                variant="contained"
                className="button"
                onClick={() => navigate(-1)}
             >
               Take me back
              </Button>
            </Box>
        </Container>
    </FallbackPageStyles>
  );
};


export default FallbackPage;
